<!-- 业务合作 -->
<template>
  <div id="app">
    <div class="web_container">
      <div class="body_container">
        <!-- 头部 -->
        <div class="header_container">
          <span class="header_title">业务合作</span>
          <div class="header_content_container">
            <div class="item_contain" v-for="item in items">
              <div class="no_bg">
                <span class="item_no">{{item.index+1}}·</span>
              </div>
              <div class="title_bg">
                <span class="item_tittle">{{item.title}}</span>
              </div>
              <span class="item_dec">{{item.dec}}</span>
            </div>
          </div>
        </div>
        <!-- 内容 -->
        <div class="content_container">
          <span class="content_hint">如您有以上业务需求，欢迎扫码加合作微信</span>
          <img class="content_img" src="../assets/business_cooperation/ico_qrcode.png" />
          <span class="content_code">猫砍大画管事猫<br />微信号：hxx2017hz</span>
          <!-- 分割线 -->
          <div class="line"></div>
        </div>
      </div>
    </div>

    <div class="phone_container">
      <div class="phone_body_container">
        <!-- 头部 -->
        <div class="phone_header_container">
          <span class="phone_header_title">业务合作</span>
          <span class="phone_header_dec">我们开放接纳多种合作方式</span>
        </div>
        <!-- 内容 -->
        <div class="phone_content_container">
          <div class="phone_item_contain" v-for="(item,index) in items" :class="index == 1?'phone_item_margin':''">
            <div class="phone_title_bg">
              <span class="phone_item_tittle">{{item.title}}</span>
            </div>
            <span class="phone_item_dec">{{item.dec}}</span>
          </div>
          <span class="phone_content_hint">如您有以上业务需求，欢迎扫码加合作微信</span>
          <img class="phone_content_img" src="../assets/business_cooperation/phone_ico_qrcode.png" />
          <span class="phone_content_code">猫砍大画管事猫<br />微信号：hxx2017hz</span>
          <!-- 分割线 -->
          <div class="phone_line"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'businessCooperation ',
    data() {
      return {
        items: [{
            title: '原创艺术家合作',
            dec: '欢迎入驻猫砍大画旗舰店',
            index: 0
          },
          {
            title: '承接条漫创作',
            dec: '传统文化相关的条漫创作',
            index: 1
          },
          {
            title: '承接产品研发',
            dec: '手机app、小程序等软件研发',
            index: 2
          }
        ],
      };
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: ht;
    src: url("../assets/font/HT.otf");
  }

  .web_container {
    width: 100%;
  }

  .body_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header_container {
    background-size: 100%;
    width: 100%;
    height: 25vw;
    background-image: url('../assets/home/bg_header.png');
    /* background-repeat: no-repeat; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header_title {
    font-family: ht;
    font-size: 2.5vw;
    color: #000000;
    margin-top: 10.416666vw;
  }

  .header_content_container {
    display: flex;
    margin-top: 3.59375vw;
  }

  .item_contain {
    display: flex;
    flex-direction: column;
    margin-left: 2.5vw;
  }

  .no_bg {
    background-size: 100%;
    height: 2.8125vw;
    width: 3.125vw;
    background-image: url(../assets/business_cooperation/bg_number.png);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .item_no {
    font-family: ht;
    font-size: 2.083333vw;
    color: #FFFFFF;
  }

  .title_bg {
    background-size: 100%;
    height: 2.8125vw;
    width: 12.447916vw;
    background-image: url(../assets/business_cooperation/bg_title.png);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.78125vw;
  }

  .item_tittle {
    font-family: ht;
    font-size: 1.25vw;
    color: #58351A;
  }

  .item_dec {
    font-family: ht;
    font-size: 1.041666vw;
    color: #58351A;
    margin-top: 0.416666vw;
  }

  .line {
    height: 0.052083vw;
    width: 52.083333vw;
    background-color: rgba(151, 151, 151, 0.3);
    margin-top: 4.166666vw;
    margin-bottom: 4.166666vw;
  }

  .content_container {
    background-size: 100%;
    width: 100%;
    background-image: url('../assets/home/bg_content.png');
    background-repeat: repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .content_hint {
    font-family: ht;
    font-size: 1.25vw;
    color: #4E4D4D;
    margin-top: 3.854166vw;
  }

  .content_img {
    height: 10.416666vw;
    width: 10.416666vw;
    margin-top: 1.25vw;
  }

  .content_code {
    font-family: ht;
    font-size: 1.25vw;
    color: #58351A;
    margin-top: 0.833333vw;
  }

  .phone_container {
    width: 100%;
  }

  .phone_body_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_header_container {
    background-size: 100%;
    width: 100%;
    height: 78.933333vw;
    background-image: url('../assets/home/phone_bg_header.png');
    /* background-repeat: no-repeat; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .phone_header_title {
    font-family: ht;
    font-size: 6.4vw;
    color: #000000;
    margin-top: 38.933333vw;
  }

  .phone_header_dec {
    font-family: ht;
    font-size: 4.266666vw;
    color: #4E4D4D;
    margin-top: 2.133333vw;
  }

  .phone_content_container {
    background-size: 100%;
    width: 100%;
    background-image: url('../assets/home/bg_content.png');
    background-repeat: repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .phone_item_contain {
    display: flex;
    flex-direction: column;
    margin-bottom:19.2vw;
  }

  .phone_item_margin{
    margin-left:10.4vw;
  }

  .phone_title_bg {
    background-size: 100%;
    height: 12vw;
    width: 53.066666vw;
    background-image: url(../assets/business_cooperation/phone_bg_title.png);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .phone_item_tittle {
    font-family: ht;
    font-size: 5.333333vw;
    color: #58351A;
  }

  .phone_item_dec {
    font-family: ht;
    font-size: 4.266666vw;
    color: #58351A;
    margin-top: 1.6vw;
  }

  .phone_content_hint {
    font-family: ht;
    font-size: 4.266666vw;
    color: #4E4D4D;
    margin-top: 2.133333vw;
  }

  .phone_content_img {
    height: 25.6vw;
    width: 25.6vw;
    margin-top: 4.266666vw;
  }

  .phone_content_code {
    font-family: ht;
    font-size: 4.266666vw;
    color: #58351A;
    margin-top: 6.4vw;
  }

  .phone_line {
    height: 0.266666vw;
    width: 89.333333vw;
    background-color: rgba(151, 151, 151, 0.3);
    margin-top: 17.066666vw;
    margin-bottom: 8.266666vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/BusinessCooperation.vue